module.exports = __webpack_public_path__ + "static/media/3_col_6.6ba5a569.jpg";